// Share Toggle Button with Dialog for Desktop and Native Sharing for Mobile
var ShareToggleButton = class extends HTMLButtonElement {
    constructor() {
        super();
        this.addEventListener("click", this._onButtonClick.bind(this));
        this._setupCopyButtons();
        this._setupDialogListeners();
        this.setAttribute('data-share-button', 'true');
    }
    
    _onButtonClick(event) {
        event.preventDefault();
        

        
        const isMobile = window.matchMedia('(max-width: 1099px)').matches;
        
        if (isMobile && navigator.share) {
            // Use native sharing on mobile
            navigator.share({
                title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
                url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
            }).catch((error) => {
                // Don't show fallback for user cancellation or successful completion
                // Only show fallback for actual permission/capability errors
                if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') {
                    this._showMobileMenu();
                }
                // Ignore AbortError (user canceled) and other success-related errors
            });
        } else if (isMobile) {
            // Mobile fallback - show mobile menu
            this._showMobileMenu();
        } else {
            // Desktop - show dialog
            this._showDialog();
        }
    }
    
    _showDialog() {
        const dialogId = this.getAttribute("aria-controls");
        const dialog = document.getElementById(dialogId);
        
        if (dialog) {
            dialog.showModal();
            dialog.classList.add('share-dialog--open');
            
            // Focus the first focusable element
            const firstInput = dialog.querySelector('input, button');
            if (firstInput) {
                firstInput.focus();
            }
        }
    }
    
    _showMobileMenu() {
        // Fallback for mobile devices without native sharing
        const mobileMenuId = this.getAttribute("aria-controls").replace('share-dialog-', 'mobile-share-buttons-');
        const mobileMenu = document.getElementById(mobileMenuId);
        
        if (mobileMenu) {
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            this.setAttribute("aria-expanded", !isExpanded ? "true" : "false");
            mobileMenu.style.display = !isExpanded ? "block" : "none";
        }
    }
    
    _setupDialogListeners() {
        // Setup close dialog listeners
        document.addEventListener('click', (event) => {
            if (event.target.closest('.share-dialog__close')) {
                const dialog = event.target.closest('dialog');
                if (dialog) {
                    this._closeDialog(dialog);
                }
            }
        });
        
        // Close dialog on backdrop click
        document.addEventListener('click', (event) => {
            if (event.target.tagName === 'DIALOG') {
                const rect = event.target.getBoundingClientRect();
                const isInDialog = (
                    rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
                    rect.left <= event.clientX && event.clientX <= rect.left + rect.width
                );
                
                if (!isInDialog) {
                    this._closeDialog(event.target);
                }
            }
        });
        
        // Close dialog on Escape key
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                const openDialog = document.querySelector('dialog[open].share-dialog');
                if (openDialog) {
                    this._closeDialog(openDialog);
                }
            }
        });
    }
    
    _closeDialog(dialog) {
        dialog.classList.remove('share-dialog--open');
        dialog.classList.add('share-dialog--closing');
        
        // Wait for animation to complete before closing
        setTimeout(() => {
            dialog.close();
            dialog.classList.remove('share-dialog--closing');
        }, 200);
    }
    
    _setupCopyButtons() {
        // Setup copy to clipboard functionality
        document.addEventListener('click', (event) => {
            if (event.target.closest('.share-dialog__copy-btn')) {
                const button = event.target.closest('.share-dialog__copy-btn');
                const targetSelector = button.getAttribute('data-copy-target');
                const input = document.querySelector(targetSelector);
                
                if (input) {
                    this._copyToClipboard(input.value, button);
                }
            }
        });
    }
    
    async _copyToClipboard(text, button) {
        try {
            await navigator.clipboard.writeText(text);
            this._showCopySuccess(button);
        } catch (err) {
            // Fallback for older browsers
            this._fallbackCopyToClipboard(text, button);
        }
    }
    
    _fallbackCopyToClipboard(text, button) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
            document.execCommand('copy');
            this._showCopySuccess(button);
        } catch (err) {
            // Silent fail
        }
        
        document.body.removeChild(textArea);
    }
    
    _showCopySuccess(button) {
        const copyText = button.querySelector('.copy-text');
        const successText = button.querySelector('.copy-success');
        
        if (copyText && successText) {
            copyText.classList.add('hidden');
            successText.classList.remove('hidden');
            
            // Reset after 2 seconds
            setTimeout(() => {
                copyText.classList.remove('hidden');
                successText.classList.add('hidden');
            }, 2000);
        }
    }
};

window.customElements.define("share-toggle-button", ShareToggleButton, { extends: "button" });

// Fallback for cases where custom elements don't work
document.addEventListener('DOMContentLoaded', function() {
    // Find all share buttons and add click listeners
    const shareButtons = document.querySelectorAll('button[is="share-toggle-button"]');
    
    shareButtons.forEach(button => {
        if (!button.hasAttribute('data-share-button')) {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                

                
                // Simple mobile/desktop detection
                const isMobile = window.matchMedia('(max-width: 1099px)').matches;
                
                if (isMobile && navigator.share) {
                    // Use exact same pattern as working example
                    // Add small delay to mimic the alert timing that was working
                    setTimeout(() => {
                        navigator.share({
                            title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
                            url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
                        }).catch((error) => {
                            // Ignore all errors - native sharing handles its own flow
                            // AbortError happens on both cancel and success
                        });
                    }, 100);
                } else if (isMobile) {
                    const shareUrl = this.getAttribute("share-url") || window.location.href;
                    // Fallback: copy to clipboard or show mobile menu
                    navigator.clipboard?.writeText(shareUrl);
                } else {
                    // Desktop - show dialog (handled by custom element)
                }
            });
        }
    });
});